import { useSEO } from "@/lib/hooks";

const PAGES = {
  mentions: {
    title: "Mentions légales", body: [
      ["Éditeur", "Depann7 — service de dépannage et remorquage en Île-de-France. Téléphone : +33 7 53 95 58 90. Email : Contact.depannidf@gmail.com."],
      ["Hébergement", "Le site est hébergé sur infrastructure cloud sécurisée."],
      ["Propriété intellectuelle", "L'ensemble des contenus présents sur ce site (textes, images, logos) sont la propriété de Depann7 ou de ses partenaires et sont protégés par les législations française et internationale."],
      ["Responsabilité", "Les informations diffusées sur le site sont fournies à titre indicatif et peuvent être modifiées sans préavis."],
    ],
  },
  cgv: {
    title: "Conditions générales de vente", body: [
      ["Objet", "Les présentes CGV régissent les prestations de dépannage, remorquage et transport de véhicules réalisées par Depann7."],
      ["Tarifs", "Les tarifs annoncés sont indicatifs. Le prix final est confirmé par téléphone avant intervention selon la distance, l'urgence, l'accessibilité et l'état du véhicule."],
      ["Paiement", "Les paiements sont acceptés par carte bancaire, espèces ou virement. Pour les professionnels, une facturation mensuelle est possible sur devis."],
      ["Annulation", "Toute annulation après le départ du dépanneur peut entraîner une facturation forfaitaire."],
      ["Réclamations", "Toute réclamation doit être adressée par écrit à Contact.depannidf@gmail.com dans un délai de 30 jours."],
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité", body: [
      ["Données collectées", "Nous collectons uniquement les données nécessaires au traitement de votre demande (nom, téléphone, email, adresse, véhicule)."],
      ["Finalité", "Ces données sont utilisées exclusivement pour traiter votre demande, l'intervention et la facturation."],
      ["Conservation", "Les données sont conservées pendant la durée légale de conservation des documents commerciaux."],
      ["Droits", "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous à Contact.depannidf@gmail.com."],
    ],
  },
  cookies: {
    title: "Politique de cookies", body: [
      ["Cookies essentiels", "Nous utilisons uniquement des cookies techniques nécessaires au bon fonctionnement du site."],
      ["Cookies analytiques", "Aucun cookie de tracking publicitaire n'est déposé sans votre consentement explicite."],
      ["Gestion", "Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur."],
    ],
  },
};

export default function LegalPages({ page }) {
  const data = PAGES[page] || PAGES.mentions;
  useSEO({ title: `${data.title} — Depann7` });
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-16">
        <h1 className="text-3xl font-extrabold text-txt-900">{data.title}</h1>
        <div className="space-y-6 mt-8">
          {data.body.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-bold text-brand text-lg">{h}</h2>
              <p className="text-txt-700 mt-2 leading-relaxed">{p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
